// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"201":"60f4d772","218":"b5e7e130","271":"02e6fec3","340":"06fabfd7","869":"4afd28d8"}[chunkId] + ".css";
};